import { mapCriteriaToQuery } from '../mapCriteriaToQuery';

export const addPromotionQuery = ({ queryString, criteria, valid }) => {
	const searchParams = new URLSearchParams(queryString);
	if (!valid) {
		searchParams.delete('promo');
		return decodeURIComponent(searchParams.toString());
	}

	searchParams.delete('search');
	if (criteria.length > 0) {
		const queryCriteria = mapCriteriaToQuery({ criteria });
		searchParams.set('search', queryCriteria);
	}

	searchParams.delete('promo');
	return decodeURIComponent(searchParams.toString());
};
